import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import BlogThreeItem from './BlogThreeItem';
import blogThreeData from '../services6/blogThreeData';
import BlogTFourItem from './BlogThreeItem';

function Blog4() {
    return (
        <section className="blog-wrapper section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12 mb-20">
                        <div className="section-title-3 text-center text-md-left">
                            <p>Services</p>
                            <h1>Explore Our Services </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {blogThreeData.slice(0, 4).map((data) => (
                        <BlogTFourItem
                            key={data.id}
                            thumb={data.thumbnail}
                            title={data.title}
                            author={data.author}
                            // meta={data.meta}
                            postLink={data.link}
                            category={data.category}
                            slug={data.slug}
                        />
                    ))}
                </div>
                <div className='d-flex justify-content-center mt-5'>
                    <Link to="/services" className="theme-btn">
                        See all Services
                        <BsArrowRight style={{ fontSize: '20px', marginLeft: '15px' }} />
                    </Link>
                </div>

            </div>
        </section>
    );
}

export default Blog4;
